import { render, staticRenderFns } from "./AuxiliaryAccountingBalance.vue?vue&type=template&id=861e68f8&scoped=true&"
import script from "./AuxiliaryAccountingBalance.vue?vue&type=script&lang=js&"
export * from "./AuxiliaryAccountingBalance.vue?vue&type=script&lang=js&"
import style0 from "./AuxiliaryAccountingBalance.vue?vue&type=style&index=0&id=861e68f8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861e68f8",
  null
  
)

export default component.exports